<template>
  <md-dialog v-bind="$attrs" v-on="$listeners" :md-fullscreen="false" @md-opened="onOpened"
             @md-clicked-outside="onClickOutside">
    <loading-spinner-overlay v-if="sendingActivation"></loading-spinner-overlay>
    <md-dialog-title>登記情報提供サービスのアカウントを紐付けます</md-dialog-title>
    <md-content>
      <form class="md-layout md-alignment-center-center" autocomplete="off">
        <div class="md-layout-item md-size-90 md-small-size-100">
          <span class="md-caption">
            ※ 下記で入力されたパスワードは、本サービスでは保持しません<br/>
            ※ 利用時間外の場合は、紐付けが行えません。<br/>
            　 利用時間：平日8:30〜22:55・土日祝日8:30〜17:55
          </span>
          <flash-message v-if="activationMessage" :errors="[activationMessage]"></flash-message>
        </div>
        <div class="md-layout-item md-size-60 md-small-size-100">
          <md-card-content>
            <md-field :class="getDialogValidationClass('t_service_id')">
              <label>登記情報提供サービスID</label>
              <md-input v-model="formDialog.t_service_id" :readonly="disabledTServiceId" autocomplete="off"></md-input>
              <span class="md-error"
                    v-if="getValidationResponseMessage('t_service_id')">{{ getValidationResponseMessage('t_service_id') }}</span>
              <span class="md-error"
                    v-else-if="!$v.formDialog.t_service_id.required">{{ errors.t_service_id.required }}</span>
            </md-field>
            <md-field :class="getDialogValidationClass('password')">
              <label>パスワード</label>
              <md-input type="password" v-model="formDialog.password" :disabled="sendingActivation"
                        autocomplete="off"></md-input>
              <md-input v-show="false" type="password"></md-input><!-- パスワードが補完されないようにダミーを生成 -->
              <span class="md-error"
                    v-if="getValidationResponseMessage('password')">{{ getValidationResponseMessage('password') }}</span>
              <span class="md-error"
                    v-else-if="!$v.formDialog.password.required">{{ errors.password.required }}</span>
            </md-field>
          </md-card-content>
        </div>
      </form>
    </md-content>
    <md-dialog-actions class="md-layout md-alignment-center-right">
      <md-button :disabled="sendingActivation" @click="onClose" class="md-raised">
        <md-icon>close</md-icon>
        <label>閉じる</label>
      </md-button>
      <md-button class="md-primary md-raised" @click="submitActivationForm()" :disabled="sendingActivation">
        <md-icon>link</md-icon>
        <label>認証</label>
      </md-button>
    </md-dialog-actions>
  </md-dialog>
</template>

<script>
import FlashMessage                                    from "../components/FlashMessage";
import LoadingSpinnerOverlay                           from "./LoadingSpinnerOverlay";
import {validationMixin}                               from "vuelidate"
import {required}                                      from "vuelidate/lib/validators"
import Validation                                      from "../modules/validation";
import {apiClientWithUserToken as apiClient, apiList,} from "../modules/apiClient";
import Common                                          from "../modules/common";
import CommonMixin                                     from "../mixins/commonMixin";

export default {
    name      : 'ActivationModal',
    components: {LoadingSpinnerOverlay, FlashMessage},
    mixins    : [validationMixin, CommonMixin],
    props     : {
      t_service_id      : {
        type   : String,
        default: null,
      },
      disabledTServiceId: {
        type   : Boolean,
        default: true,
      },
    },
    data      : () => ({
      sendingActivation: false,
      tokenActivation  : null,
      activationMessage: null,
      activationRetry  : 0,
      formDialog       : {
        t_service_id: null,
        password    : null,
      },
      errors           : {
        t_service_id: {
          required: Validation.errorMessage(Validation.rules.required, 'tServiceID'),
        },
        password    : {
          required : Validation.errorMessage(Validation.rules.required, 'password'),
          minLength: Validation.errorMessage(Validation.rules.minLength, 'password', 8),
        },
      },
      confirmPassword  : true,
    }),
    validations() {
      return {
        formDialog: {
          t_service_id: {
            required,
          },
          password    : {
            required,
          },
        }
      };
    },
    methods   : {
      onOpened() {
        this.formDialog.password = null;
        this.sendingActivation   = false;
        this.activationMessage   = null;
        this.$v.formDialog.$reset();
        this.$emit('md-opened');
      },
      onClickOutside() {
        this.formDialog.password = null;
        this.sendingActivation   = false;
        this.activationMessage   = null;
        this.$v.formDialog.$reset();
        this.onClose();
        this.$emit('md-clicked-outside');
      },
      onClose() {
        this.$emit('close');
        this.$emit('update:mdActive', false)
      },
      /**
       * Submit activation form
       */
      submitActivationForm() {
        this.$v.formDialog.t_service_id.$touch();
        this.$v.formDialog.password.$touch();
        if (!this.$v.formDialog.$invalid) {
          this.tokenActivation   = null;
          this.sendingActivation = true;
          this.activationMessage = null;
          this.activationRetry   = 0;
          apiClient
            .post(apiList.jon.activation, {
              t_service_id: this.formDialog.t_service_id,
              password    : this.formDialog.password,
            })
            .then(response => {
              if (response.data.token) {
                this.activationMessage = null;
                this.tokenActivation   = response.data.token;
                this.fetchActivationInformation();
                return;
              } else if (response.data.errors) {
                this.tokenActivation   = null;
                this.activationMessage = response.data.errors.pop();
                this.sendingActivation = false;
                return;
              }
              this.activationMessage = Common.messages.activation.error;
            })
            .catch(error => {
              this.tokenActivation   = null;
              this.activationMessage = Common.messages.activation.error;
              this.sendingActivation = false;
            })
            .finally(() => {
            });
        }
      },
      fetchActivationInformation() {
        if (!this.$attrs['md-active']) {
          return;
        }
        apiClient
          .get(apiList.jon.activation, {
            params: {token: this.tokenActivation},
          })
          .then(response => {
            if (response.data.errors) {
              this.tokenActivation   = null;
              this.sendingActivation = false;
              this.activationMessage = response.data.errors[0] ? response.data.errors[0] : Common.messages.activation.error;
              return;
            }
            this.activationRetry += 1;
            const activation = response.data;
            if (activation.is_available === 1) {
              this.activationMessage = null;
              this.sendingActivation = false;
              this.$emit('activationSuccess', this.formDialog.t_service_id);
            } else if (activation.is_available === null && activation.error === null) {
              if (this.activationRetry >= Common.maximumActivationRetry) {
                this.tokenActivation   = null;
                this.sendingActivation = false;
                this.activationMessage = Common.messages.reachMaximumRetry;
                return;
              }
              Common.sleep(Common.checkActivationInterval).then(() => {
                this.fetchActivationInformation();
              });
            } else {
              this.tokenActivation   = null;
              this.sendingActivation = false;
              this.activationMessage = activation.error;
            }
          })
          .catch(error => {
            this.tokenActivation   = null;
            this.sendingActivation = false;
            this.activationMessage = Common.messages.activation.error;
          });
      },
    },
    watch     : {
      t_service_id: function (tServiceId) {
        this.formDialog.t_service_id = tServiceId;
      },
    },
  }
</script>

<style lang="scss" scoped>
  .md-dialog {
    min-width: 400px;
  }

  .ie-browser ~ .md-dialog {
    left: 50%;
    transform: translateX(-50%);
  }
</style>
